/*
    Taken from: https://stackoverflow.com/questions/12374110/converting-woo-commerce-dropdowns-into-radio-buttons
*/

/* ------------------------------------*\
    VARIABLE DECLARATION
\*------------------------------------*/
let all_variations;
let all_variations_sorted = [];
let b6_variations = [];
let b4_variations = [];
let b2_variations = [];
let $variation_form;

let variations_match_count=0;

/*------------------------------------*\
Variable Subscription methods
\*------------------------------------*/

function setupVariableSubscription(){
    $variation_form = $('form.variations_form');
    var $month_radio = $('input').find('[data-input-group="box-type"]');

    $variation_form
    //setup on change
        .on('change','input:radio',function(e){
            // console.log('change');
            // console.log(this);
            // console.log($(this).data('inputGroup'));


            $variation_form
                .trigger( 'woocommerce_variation_radio_change' )
                .trigger( 'check_variations', [ '', false, $(this).data('inputGroup') ] );

            $(this).trigger('blur');
            if( $().uniform && typeof $.uniform.update === "function" ) {
                $.uniform.update();
            }
        })
    // Upon gaining focus
        .on( 'focusin','', function( event ) {
            $variation_form
                .trigger( 'woocommerce_variation_radio_focusin' )
                .trigger( 'check_variations', [ $(this).attr('name'), true ] );

        } )
    // Check variations
        .on( 'check_variations', function( event, exclude, focus, elementType ) {
            // console.log('check_variations')
            // console.log($(this).data('inputGroup'));

            var all_set             = true;
            var any_set             = false;
            var showing_variation   = false;
            var current_settings    = {};
            var $variation_form     = $(this);
            var $reset_variations   = $variation_form.find('.reset_variations');
            var value = "";

            $variation_form.find('input:radio:checked').each( function() {
                if ( $(this).val().length == 0 ) {
                    all_set = false;
                } else {
                    any_set = true;
                }

                if ( exclude && $(this).attr('name') == exclude ) {

                    all_set = false;
                    current_settings[$(this).attr('name')] = '';

                } else {

                    // Encode entities
                    value = $(this).val()
                        .replace(/&/g, '&')
                        .replace(/"/g, '"')
                        .replace(/'/g, "'")
                        .replace(/</g, '<')
                        .replace(/>/g, '>');

                    // Add to settings array
                    current_settings[ $(this).attr('name') ] = value;
                }

            });

            var product_id          = parseInt( $variation_form.attr( 'data-product_id' ) );
            all_variations      = window[ "product_variations_" + product_id ];

            // Fallback
            if ( ! all_variations ){
                all_variations = window[ "product_variations" ];
            }
            var matching_variations = find_matching_variations( all_variations, current_settings );


            if(!all_variations_sorted.length === undefined || all_variations_sorted.length == 0){
                all_variations_sorted = sort_variations(all_variations);
            }
            if ( all_set ) {
                var variation = matching_variations.pop();
                if ( variation ) {
                    if ( ! exclude ) {
                        $variation_form.find('.single_variation_wrap').slideDown('200');
                    }
                    // Found - set ID
                    $variation_form
                        .find('input[name=variation_id]')
                        .val( variation.variation_id )
                        .trigger('change');
                    $variation_form
                        .find('#a_variation_id')
                        .attr('href', '/cart/?add-to-cart='+variation.variation_id );

                    $variation_form.trigger( 'found_variation', [ variation, elementType ] );

                } else {
                    // $($('input[data-input-group="subscription-type"]')[1]).trigger('click');
                    // Nothing found - reset fields
                    //$variation_form.find('.variations input:radio').val('');
                    if ( ! exclude ) {
                        $variation_form.find('.single_variation_wrap').slideUp('200');
                    }
                    if ( ! focus )
                        $variation_form.trigger( 'reset_image' );
                }

            } else {

                $variation_form.trigger( 'update_variation_values', [ matching_variations ] );

                if ( ! focus )
                    $variation_form.trigger( 'reset_image' );

                if ( ! exclude ) {
                    $variation_form.find('.single_variation_wrap').slideUp('200');
                }

            }

            if ( any_set ) {

                if ( $reset_variations.css('visibility') == 'hidden' )
                    $reset_variations.css('visibility','visible').hide().fadeIn();

            } else {

                $reset_variations.css('visibility','hidden');

            }

        } )
    // Reset product image
        .on( 'reset_image', function( event ) {
            var $product        = $(this).closest( '.product' );
            var $product_img    = $product.find( 'div.images img:eq(0)' );
            var $product_link   = $product.find( 'div.images a.zoom:eq(0)' );
            var o_src           = $product_img.attr('data-o_src');
            var o_title         = $product_img.attr('data-o_title');
            var o_href          = $product_link.attr('data-o_href');

            if ( o_src && o_href && o_title ) {
                $product_img
                    .attr( 'src', o_src )
                    .attr( 'alt', o_title )
                    .attr( 'title', o_title );
                $product_link
                    .attr( 'href', o_href );
            }

        } )

    // Disable option fields that are unavaiable for current set of attributes
        .on( 'update_variation_values', function( event, variations ) {
            // Loop through selects and disable/enable options based on selections
            $variation_form.find('input:radio').each(function( index, el ){

                var current_attr_radio = $(el);

                // Disable all
                current_attr_radio.find('option:gt(0)').attr('checked', 'checked');

                // Get name
                var current_attr_name   = current_attr_radio.attr('name');

                var num;
                // Loop through variations
                for ( num in variations ) {

                    var attributes = variations[ num ].attributes;
                    var varattr_name;
                    for ( varattr_name in attributes ) {

                        var attr_val = attributes[ attr_name ];

                        if ( attr_name == current_attr_name ) {

                            if ( attr_val ) {

                                // Decode entities
                                attr_val = $("<div/>").html( attr_val ).text();

                                // Add slashes
                                attr_val = attr_val.replace(/'/g, "\\'");
                                attr_val = attr_val.replace(/"/g, "\\\"");

                                // Compare the meercat
                                current_attr_radio.find('option[value="' + attr_val + '"]').removeAttr('checked');

                            } else {
                                current_attr_radio.find('option').removeAttr('checked');
                            }

                        }

                    }

                }

            });

            // Custom event for when variations have been updated
            $variation_form.trigger('woocommerce_update_variation_values');

        } )

        // Show single variation details (price, stock, image)
        .on( 'found_variation', function( event, variation, elementType ) {

            if(elementType === 'box-type'){
                if(b6_variations.findIndex(x => x.variation_id === variation.variation_id)!= -1){
                    updateRadioButtonsMonth('6bottles');
                }
                if(b4_variations.findIndex(x => x.variation_id === variation.variation_id) != -1){
                    updateRadioButtonsMonth('4bottles');
                }
                if(b2_variations.findIndex(x => x.variation_id === variation.variation_id) != -1){
                    updateRadioButtonsMonth('2bottles');
                }
            }



        } );


    $('form.variations_form input:radio').trigger('change');

    setupSelectionOfSubscription();
    setupScrollToIcon();
}

// Search for matching variations for given set of attributes
function find_matching_variations( product_variations, settings ) {
    var matching = [];
    for (var i = 0; i < product_variations.length; i++) {
        var variation = product_variations[i];
        if ( variations_match( variation.attributes, settings ) ) {
            matching.push(variation);
        }
    }
    return matching;
}
// Check if two arrays of attributes match
function variations_match( attrs1, attrs2 ) {
    var match = true;
    var attr_name;
    for ( attr_name in attrs1 ) {
        var val1="";
        var val2="";
        if(variations_match_count>1){
            val1 = String(attrs1[ attr_name ]).toLowerCase();
            val2 = String(attrs2[ attr_name ]).toLowerCase();
        }else{
            val1 =attrs1[ attr_name ];
            val2 = attrs2[ attr_name ];
            variations_match_count++;
        }
        if ( val1 !== undefined && val2 !== undefined && val1.length != 0 && val2.length != 0 && val1 != val2 ) {
            match = false;
        }
    }
    return match;
}
// Check if two arrays of attributes match
function sort_variations( all_variations ) {
    all_variations.forEach(function(e){
        var aux = {
            'variation_id': e.variation_id,
            'is_in_stock': e.is_in_stock,
            'attributes': e.attributes,
            'display_regular_price': e.display_regular_price,
            'stock_qtty': e.max_qty || 0,
            'variation': e
        };
        if(e.attributes['attribute_pa_box-size'] === 'six-bottle-box'){
            b6_variations.push(aux);
        }else if(e.attributes['attribute_pa_box-size'] === 'four-bottle-box'){
            b4_variations.push(aux);
        }else if(e.attributes['attribute_pa_box-size'] === 'two-bottle-box'){
            b2_variations.push(aux);
        }
        all_variations_sorted.push(aux);
    });

    return all_variations;
}

function updateRadioButtonsMonth(type){
    var first_has_stock = false;
    if(type === '6bottles'){
        b6_variations.forEach(function(e,index){
            if(e.is_in_stock){
                if(index === 0){
                    first_has_stock = true;
                    $($('input[data-input-group="subscription-type"]')[index]).attr('disabled',false).attr('checked',true);
                }else{
                    if(!first_has_stock){
                        $($('input[data-input-group="subscription-type"]')[index]).attr('disabled',false);
                        $($('input[data-input-group="subscription-type"]')[index]).attr('checked',true).trigger('click');
                    }
                }
            }else{
                $($('input[data-input-group="subscription-type"]')[index]).attr('disabled','true').attr('checked',false);
            }
        });
    } else if(type === '4bottles'){
        b4_variations.forEach(function(e,index){
            if(e.is_in_stock){
                // console.log('variabiel in stock ', index, first_has_stock);
                if(index === 0){
                    first_has_stock = true;
                    $($('input[data-input-group="subscription-type"]')[index]).attr('disabled',false).attr('checked',true);
                }else{
                    if(!first_has_stock){
                        $($('input[data-input-group="subscription-type"]')[index]).attr('disabled',false).attr('checked',true);
                    }
                }
            }else{
                // console.log('variabiel not in stock ', index, first_has_stock);
                $($('input[data-input-group="subscription-type"]')[index]).attr('disabled','true').attr('checked',false);
            }
        });
    } else if(type === '2bottles'){
        b2_variations.forEach(function(e,index){
            if(e.is_in_stock){
                if(index === 0){
                    first_has_stock = true;
                    $($('input[data-input-group="subscription-type"]')[index]).attr('disabled',false).attr('checked',true);
                }else{
                    if(!first_has_stock){
                        $($('input[data-input-group="subscription-type"]')[index]).attr('disabled',false);
                        $($('input[data-input-group="subscription-type"]')[index]).attr('checked',true).trigger('click');
                    }
                }
            }else{
                $($('input[data-input-group="subscription-type"]')[index]).attr('disabled','true').attr('checked',false);
            }
        });

    }
    // $variation_form
    //     .trigger( 'woocommerce_variation_radio_change' )
    //     .trigger( 'check_variations', [ '', false, $(this).data('inputGroup') ] );
    // $variation_form.trigger('blur');
    // if( $().uniform && typeof $.uniform.update === "function" ) {
    //     $.uniform.update();
    // }
}
function setupSelectionOfSubscription(){
    const $selection_box = $('.bottle-selection-box');
    const $b_select_toggle = $('.bottle-selection-options-option');

    $b_select_toggle.on('click',function(){
        console.log(this);
        var group_id = $(this).attr('data-group');
        $b_select_toggle.removeClass('active');
        $(this).addClass('active');
        $selection_box.attr('data-selected-group',group_id);
    });

}


function setupScrollToIcon(){
    var controller = new ScrollMagic.Controller();

    // build scenes
    new ScrollMagic.Scene({triggerElement: ".p-product-qa"})
        .setClassToggle("#footer-row-sticky-scrollto", "show_arrow") // add class toggle
        // .addIndicators() // add indicators (requires plugin)
        .triggerHook(0.85)
        .duration($('#scroll_to_section_trigger').outerHeight() + $('.footer-inside').outerHeight())
        .addTo(controller);


    $('#footer-row-sticky-scrollto').on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();

        if($(this).hasClass('show_arrow')){
            // trigger scroll
            $('html, body').animate({
                scrollTop:0
            }, 300);
        }else{
            // trigger scroll
            $('html, body').animate({
                scrollTop: $('.p-product-qa').offset().top
            }, 300);
        }


    });
}
